export enum HeaderDataHooks {
  Main = 'header',
  FiltersContainer = 'filters-container',
  FiltersWrapper = 'filters-wrapper',
  WeeklyDatepickerContainer = 'weekly-datepicker-container',
}
